import { Button, SizableText, SmartLink, Stack, YStack, isWeb } from '@my/ui'
import { FeaturedContentBlock } from './featured-content.block'
import { SolitoImage } from 'solito/image'
import { LinearGradient } from '@tamagui/linear-gradient'

export const FeaturedContentComponent = (block: FeaturedContentBlock) => {
  return (
    <YStack position="relative" flex={1} height="100%" minHeight={358} $gtSm={{ minHeight: 500 }}>
      <YStack borderRadius="$3" overflow="hidden" bg="$white" flex={1} flexGrow={1}>
        <Stack pos="absolute" flex={1} overflow="hidden" w="100%" h="100%">
          <SolitoImage
            src={block.featuredContentImage?.url}
            alt={block.featuredContentImage?.alt || block.featuredContentTitle}
            contentFit="cover"
            fill
            sizes="(max-width: 900px) 100vw, 892px"
            priority={block.imagePriority}
          />
        </Stack>

        {isWeb ? (
          <div
            style={{
              backgroundImage: 'linear-gradient(0deg, rgba(0,0,0,0.7), rgba(0,0,0,.07))',
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          />
        ) : (
          <LinearGradient
            width="100%"
            height="100%"
            position="absolute"
            bottom="$0"
            left="$0"
            colors={['$overlay13', '$overlay0']}
            start={[0, 1]}
            end={[0, 0]}
          />
        )}

        <YStack mt='auto' width="100%" bottom="$0" p="$3.5" $gtSm={{ p: '$6' }}>
          <SizableText
            color="$white"
            size="$6"
            fow="800"
            numberOfLines={2}
            zIndex="$1"
            $gtSm={{
              size: '$9',
              fow: '800',
            }}
          >
            {block.featuredContentTitle}
          </SizableText>
          {block.featuredContentDescription && (
            <SizableText
              size="$4"
              numberOfLines={2}
              color="$white"
              $gtSm={{
                size: '$7',
              }}
            >
              {block.featuredContentDescription}
            </SizableText>
          )}

          <SmartLink
            Component={Button}
            href={block.featuredContentLink}
            theme="white"
            fontWeight="500"
            size="$5"
            color="$offBlack"
            px="$4"
            mt="$3.5"
            h={48}
            zIndex="$1"
          >
            {block.featuredContentLinkText}
          </SmartLink>
        </YStack>
      </YStack>
    </YStack>
  )
}
